import {
  ApiBlueprint,
  createApiFactory,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  apiDocsConfigRef,
  defaultDefinitionWidgets,
} from '@backstage/plugin-api-docs';
import { ApiEntity } from '@backstage/catalog-model';
import { createBackendProxyingOpenApiDefinitionWidget } from '../../components/openapi/BackendProxyingOpenApiDefinitionWidget';
import { apiExplorerPageOverride } from './apiExplorerPage';

// For OpenApi Swagger UI backend proxy based on https://github.com/backstage/backstage/tree/master/plugins/api-docs#adding-requestinterceptor-to-swagger-ui
export function createApiDocsConfig() {
  const definitionWidgets = defaultDefinitionWidgets().map(obj => {
    if (obj.type === 'openapi') {
      return {
        ...obj,
        component: (definition: any) =>
          createBackendProxyingOpenApiDefinitionWidget(definition),
      };
    }
    return obj;
  });

  return {
    getApiDefinitionWidget: (apiEntity: ApiEntity) => {
      return definitionWidgets.find(d => d.type === apiEntity.spec.type);
    },
  };
}

// PAT-1022: the api-docs plugin is the upstream `/alpha` one, whose config API
// is `api:api-docs/config`. The extension name `config` gives this one the same
// id, so it replaces the plugin's default definition widgets instead of being
// rejected as a second factory for `apiDocsConfigRef`
// (`API_FACTORY_CONFLICT`); the old `plugin.api-docs.config` name only matched
// the legacy-converted plugin. Pinned by index.test.ts.
//
// `apiExplorerPageOverride` replaces `page:api-docs` to restore the persisted
// user-list filter (see apiExplorerPage.tsx).
export const apiDocsModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [
    ApiBlueprint.make({
      name: 'config',
      params: defineParams =>
        defineParams(
          createApiFactory({
            api: apiDocsConfigRef,
            deps: {},
            factory: createApiDocsConfig,
          }),
        ),
    }),
    apiExplorerPageOverride,
  ],
});
